import { forwardRef } from 'react'
import styled from 'styled-components'

import { features } from '@h2/components/media'

import { Panel as PanelBase } from '../../../panel'

const StyledPanel = styled(PanelBase)`
  @media (${features.minWidth.laptop}) {
    > div:first-child {
      width: auto;
    }
  }
`
const Panel = forwardRef(function Panel(props, ref) {
  return <StyledPanel ref={ref} {...props} />
})

export { Panel }
